import React from "react";
import { useDispatch } from "react-redux";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Icons
import timeoutImg from "../../assets/icons/timeout_icon.svg";

// Config
import colors from "../../config/colors";
import useTranslate from "../../hooks/useTranslate";

// Actions
import { onSignIn } from "../../state/user/actions";

// Components
import Button from "../../components/Button";
import Text from "../../components/Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%"
  },
  errorTitle: {
    fontFamily: "Montserrat",
    fontSize: 60,
    lineHeight: 1,
    color: colors.riverBed,
    textTransform: "uppercase",
    marginBottom: theme.spacing(1)
  },
  errorDescription: {
    lineHeight: 1.5,
    color: colors.riverBed,
    fontSize: 26,
    fontWeight: "300"
  },
  errorDescription2: {
    lineHeight: 1.5,
    color: colors.pictonBlue,
    fontSize: 26,
    fontWeight: "300"
  },
  descriptionRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(4)
  },
  content: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    maxWidth: 400
  },
  image: {
    objectFit: "contain",
    marginBottom: theme.spacing(3)
  },
  button: {
    marginTop: theme.spacing(2),
    width: 220,
    borderRadius: 12,
    textTransform: "uppercase"
  }
}));

const AuthTimeoutPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const getText = useTranslate();

  return (
    <main className={classes.root}>
      <img className={classes.image} src={timeoutImg} alt="" />
      <Text text="authTimeoutPage.title" className={classes.errorTitle} />
      <div className={classes.descriptionRow}>
        <Text
          text="authTimeoutPage.subtitle1"
          type="subtitle2"
          className={classes.errorDescription}
        />
        <Text
          text="authTimeoutPage.subtitle2"
          type="subtitle2"
          className={classes.errorDescription2}
        />
      </div>
      <Button
        className={classes.button}
        color="primary"
        onClick={() => dispatch(onSignIn())}
        variant="contained"
        disableElevation
      >
        {getText("authTimeoutPage.button")}
      </Button>
    </main>
  );
};

export default AuthTimeoutPage;
